module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Italic.e575452.woff";